import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import SearchNav from "../../molecules/searchNav/SearchNav";
import styles from "./InterNalSearch.module.scss";
import {
	CustomContainer,
	Modal,
	connect,
	Router,
	useRouter,
} from "../../atoms/DependencyHelper";
import {
	showSpinner,
	hideSpinner,
	componentCheckSize,
} from "../../../utils/helperServices";
import { toggleSearch } from "../../../Redux/actions/navAction";
import ajaxService from "../../../utils/ajaxServices";
import * as Analytics from "../../../services/analyticsUtag";
import config from "../../../config/index"

const InterNalSearch = ({ hideNavItems, toggleSearch,globalNavigationLinks }) => {

	const [text, setText] = useState("");
	const [links, setLinks] = useState([]);

	const [showLink, setShowLink] = useState(false);

	const isTablet = componentCheckSize() <= 768;

	const router = useRouter();
	const env = config.env;
	const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
	const urlObj = globalNavigationLinks.children.find(
        (link) => link.title === "Search" && link.type === "icon"
    );
    const searchUrl = urlObj.url;
	useEffect(() => {
		async function fetchQuickLinks() {
			const linksArr = await ajaxService.httpGet(
				"drupalBaseUrl",
				"",
				"api",
				"searchQuickLinks"
			);
			setLinks([
				{
					id: 1,
					searchedHeading: "quick links",
					globalsuggestion: linksArr,
				},
			]);
		}
		fetchQuickLinks();
	}, []);

	const handleChange = (e) => {
		
		setText(e.target.value);
	};

	const closeOptions = () => {
		toggleSearch(false);
	};

	const handleKeyPress = (e) => {
		let route;
		if (searchUrl.includes("internal:"))
		{
			route = searchUrl.split("internal:")[1];
		} else {
			route = searchUrl;
		}
		if (e.key === "Enter") {
			let tempText = text;
		    tempText = tempText.replace(/\s/g, '');
			if (tempText && tempText.length) {
				closeOptions();
				showSpinner();
				router.push({ pathname: `${route}/${encodeURI(text)}` });
				hideSpinner();
			}
		}
	};
	const handleSearchClick = () => {
		let route;
		if (searchUrl.includes("internal:"))
		{
			route = searchUrl.split("internal:")[1];
		} else {
			route = searchUrl;
		}
		let tempText = text;
		tempText = tempText.replace(/\s/g, '');
		if (tempText && tempText.length) {
			closeOptions();
			showSpinner();
			router.push({ pathname: `${route}/${encodeURI(text)}`});
			hideSpinner();
		}
	};

	const handleFocus = () => {
		setShowLink(true);
		const analyticsData = Analytics.getUtagData([
			"visitor_login_status",
			"visitor_customer_id",
			"visitor_subscription_type",
			"page_site_section_lvl_1",
			"page_site_section_lvl_2",
			"page_site_section_lvl_3",
			"page_site_section_lvl_4"
		]);
		Analytics.link({
			page_tool_event: "use",
			page_tool_name: "search bar",
			page_name: "internal search",
			page_channel: "search",
			page_master_tab: "personal",
			...analyticsData,
		});
	};

	const learnMoreClicked = (linkdata, index) => {
		const url = linkdata.url;
		toggleSearch(false);
		const analyticsData = Analytics.getUtagData([
			"visitor_login_status",
			"visitor_customer_id",
			"visitor_subscription_type",
			"page_site_section_lvl_1",
			"page_site_section_lvl_2",
			"page_site_section_lvl_3",
			"page_site_section_lvl_4"
		]);
		Analytics.link({
			search_event: "quick_search",
			search_terms: linkdata.title,
			search_results: index + 1,
			search_category: "quick links",
			search_type: "quick links",
			...analyticsData,
		});

		if (url) {
			if (url.includes("internal:")) {
				let route = url.split("internal:")[1];
				if (route) {
					Router.push({
						pathname: route,
					});
				}
			} else {
				window.open(url, "_blank");
			}
		}
	};

	const searchSection = (
		<CustomContainer className={styles["internal-search-container"]}>
			<SearchNav
				handleCancel={closeOptions}
				handleChange={handleChange}
				text={text}
				handleKeyPress={handleKeyPress}
				handleSearchClick={handleSearchClick}
				handleFocus={handleFocus}
				isSearchTxt={false}
			/>
			<CustomContainer className={styles["box-conatiner"]}>
				{showLink && (
					<>
						<CustomContainer className={styles["searched-items"]}>
							{links.map((link) => (
								<CustomContainer key={link.id}>
									<CustomContainer className={styles["searched-heading"]}>
										{link.searchedHeading}
									</CustomContainer>
									{link.globalsuggestion.map((linkdata, index) => (
										<CustomContainer
											key={linkdata.id}
											className={styles["product-labels"]}
											onClick={() => learnMoreClicked(linkdata, index)}
										>
											{linkdata.title}
										</CustomContainer>
									))}
								</CustomContainer>
							))}
						</CustomContainer>
					</>
				)}
			</CustomContainer>
		</CustomContainer>
	);

	return (
		<CustomContainer>
			{isTablet ? (
				<Modal
					backdrop={false}
					show={hideNavItems}
					onHide={closeOptions}
					dialogClassName="select-modal"
				>
					{searchSection}
				</Modal>
			) : (
					<Modal
						backdrop={false}
						show={hideNavItems}
						onHide={closeOptions}
						dialogClassName="search-modal"
					>
						{searchSection}
					</Modal>
				)}
		</CustomContainer>
	);
};

InterNalSearch.propTypes = {
	hideNavItems: PropTypes.bool,
	toggleSearch: PropTypes.func,
};

const mapStateToProps = (state) => ({
	hideNavItems: state.navDetails.hideNavItems,
	globalNavigationLinks: state.navDetails.globalNav.navigationLinks,
});

export default connect(mapStateToProps, { toggleSearch })(InterNalSearch);
